<ts-page [sidenavConfig]="sidenavConfig">
  <ts-tree-menu sidenav [items]="options" [suppressHeader]="true"></ts-tree-menu>
  <router-outlet main></router-outlet>
</ts-page>
